import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faArrowUpRightFromSquare,
  faBriefcase,
  faBuilding,
  faCalendar,
  faComment,
  faClipboardListCheck,
  faClipboardQuestion,
  faClock,
  faFileArrowDown,
  faFileArrowUp,
  faFileCircleCheck,
  faFileLines,
  faFileSignature,
  faHouse,
  faInbox,
  faMoneyCheckDollar,
  faPhoneVolume,
  faUserPen,
  faCommentSmile,
} from '@fortawesome/pro-solid-svg-icons';
import { Action, ActionName } from '@app/actions/action.types';

const ACTION_ICON_MAP: Record<ActionName, IconProp> = {
  [ActionName.UploadNationalIdCard]: faFileArrowUp,
  [ActionName.UploadBankCard]: faFileArrowUp,
  [ActionName.UploadDriversLicense]: faFileArrowUp,
  [ActionName.UploadDocument]: faFileArrowUp,
  [ActionName.UploadDocumentWithSelector]: faFileArrowUp,
  [ActionName.SignDocument]: faFileSignature,
  [ActionName.SignDocumentBatch]: faFileSignature,
  [ActionName.ApproveDocument]: faFileCircleCheck,
  [ActionName.ViewDocument]: faFileLines,
  [ActionName.DownloadDocument]: faFileArrowDown,
  [ActionName.CompletePersonalData]: faUserPen,
  [ActionName.FinancialContact]: faMoneyCheckDollar,
  [ActionName.EmergencyContact]: faPhoneVolume,
  [ActionName.Company]: faBuilding,
  [ActionName.Housing]: faHouse,
  [ActionName.AppliedJobs]: faBriefcase,
  [ActionName.ShiftDetail]: faBriefcase,
  [ActionName.EventCalendarDaySelected]: faCalendar,
  [ActionName.EventCalendarShiftDetail]: faBriefcase,
  [ActionName.EventCalendarEngagementDetail]: faBriefcase,
  [ActionName.NewChatMessage]: faComment,
  [ActionName.OpenSurvey]: faClipboardQuestion,
  [ActionName.StartFlow]: faClipboardListCheck,
  [ActionName.InboxMessage]: faInbox,
  [ActionName.FeedbackWeek]: faCommentSmile,
  [ActionName.OpenAppointment]: faCalendar,
  [ActionName.OpenExternalLink]: faArrowUpRightFromSquare,
  [ActionName.OpenTimeRegistrationWeek]: faClock,
};

export function getActionIcon(action: Action): IconProp {
  return ACTION_ICON_MAP[action.name];
}
